export enum InboxType {
  ALL = 'ALL',
  TO_RECEIVE = 'TO_RECEIVE',
  RECEIVED = 'RECEIVED',
  ARCHIVED = 'ARCHIVED',
}
